<!--用户课程-->
<template>
  <a-card style="border-left: none;">
    <div class="search">
      <a-form-model layout="inline" :model="searchForm" class="search-form">
        <a-form-model-item label="用户名称">
          <a-input :maxLength="30" v-model="searchForm.userName" placeholder="请输入用户名称" />
        </a-form-model-item>
        <a-form-model-item label="年级班级">
          <a-cascader :options="gradeList" change-on-select
                      v-model="searchForm.gradeClass"
                      :fieldNames="{label: 'name', value: 'id', children: 'children'}"
                      placeholder="请选择年级班级" @change="getClassList" allowClear />
        </a-form-model-item>
        <a-form-model-item label="课程状态">
          <a-select v-model="searchForm.status" placeholder="请选择课程状态">
            <a-select-option :value="0">未开始</a-select-option>
            <a-select-option :value="1">进行中</a-select-option>
            <a-select-option :value="2">已完成</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="getPageList(1)" type="primary" html-type="button">
            查询
          </a-button>
          <a-button @click="searchReset" style="margin-left: 10px;">
            重置
          </a-button>
        </a-form-model-item>
        <a-form-model-item style="margin-left:30px;">
          <a-button type="primary" @click="updateCourse()" :loading="updateCourseLoading">更新课程</a-button>
          <a-button icon="file-sync"
                    @click="againReport" style="margin-left: 10px;" type="primary">重新生成报告
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto">
      <a-table :row-selection="rowSelection"
               style="min-width: 800px;"
               :columns="columns"
               row-key="projectCourseUserId"
               :pagination="tableRelevant.tablePagination"
               :loading="tableRelevant.tableLoading"
               :locale="tableRelevant.locale"
               :dataSource="tableRelevant.tableDataSource">
        <div slot="progress" slot-scope="text, record">
                    <span v-if="text.progress === 0">
                        <a-badge status="default" text="未开始" />
                        <a-icon type="clock-circle" theme="filled" style="margin-left: 5px;color: #c0c0c0;" />
                    </span>
          <span v-else-if="text.progress === 100">
                        <a-badge status="success" text="已完成" />&nbsp;
                        <a-icon style="color: #52c41a;" type="check-circle" />
                    </span>
          <span v-else>
                        <a-badge status="processing" text="进行中" />
                        {{ text.progress }}%
                    </span>
        </div>

        <div slot="action" slot-scope="text, record" class="action">
          <!--                    2024-06-27 16:25 黄总说智慧云有了后台就不要了，要看去智慧云看-->
          <a @click="getUserCourseChildLookReport(text)">
            <a-icon type="eye" />
            查看报告</a>
          <a @click="UserCourseSettlement(record)">
            <a-icon type="tags" />
            结算</a>
        </div>
      </a-table>
    </div>


    <!--查看报告-->
    <a-modal v-model="reportDetailVisible" :footer="null" title="查看报告" :destroyOnClose="true" :centered="true"
             width="60%">
      <a-table
        bordered
        :columns="reportDetail"
        :row-key="(text) => JSON.stringify(text)"
        :loading="reportDetailTable.tableLoading"
        :pagination="reportDetailTable.tablePagination"
        :dataSource="reportDetailTable.tableDataSource"
      >
        <div slot="course" slot-scope="text, record">
          <div class="self_td" v-for="item in text.childCourses" :key="item.id">{{ item.childCourseName }}</div>
        </div>
        <div slot="completion" slot-scope="text, record">
          <div class="self_td" v-for="item in text.childCourses" :key="item.id">
            {{ item.complateStatusName }}
          </div>
        </div>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" :disabled="!text.pdfReportUrl" @click="viewPdf(text.pdfReportUrl)">下载报告</a-button>
        </span>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";
import $Bus from "@/pages/projectImpl/js/eventBus";

const columns = [
  {
    title: "学生姓名",
    key: "2",
    dataIndex: "realName",
  },
  {
    title: "年级",
    key: "3",
    dataIndex: "gradeName",
  },
  {
    title: "班级",
    key: "4",
    dataIndex: "className",
  },
  {
    title: "课程进度",
    key: "5",
    scopedSlots: { customRender: "progress" },
  },
  {
    title: "开课时间",
    key: "6",
    dataIndex: "createTime",
  },

  {
    title: "最近使用时间",
    key: "7",
    dataIndex: "lastUpdateProgressTime",
  },
  {
    title: "操作",
    key: "9",
    scopedSlots: { customRender: "action" },
  },
];

const reportDetail = [
  { title: "报告名称", dataIndex: "reportName", align: "center" },
  { title: "关联课时", scopedSlots: { customRender: "course" }, align: "center", class: "testClass" },
  { title: "完成情况", scopedSlots: { customRender: "completion" }, align: "center", class: "testClass" },
  { title: "状态", dataIndex: "statusName", align: "center" },
  { title: "操作", scopedSlots: { customRender: "action" }, align: "center" },
];

export default {
  name: "StudentsManage",
  data() {
    return {
      columns,
      searchForm: {
        gradeId: undefined,
        classId: undefined,
        userName: undefined,
        status: undefined,
        gradeClass: undefined,
      },
      gradeList: [],
      //表格相关
      tableRelevant: tableRelevant.call(this),

      reportDetail,
      //查看报告
      reportDetailTable: tableRelevant.call(this),
      reportDetailVisible: false,

      updateCourseLoading: false,
      selectedRowKeys: [],
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  mounted() {
    setTimeout(() => this.getPageList(), 200);
    setTimeout(() => this.getGradeList(), 200);
    const arr = ["首页", "项目实施", {
      name: "课程管理",
      path: decodeURIComponent(this.$route.query.fullPath),
    }, "用户课程"];
    $Bus.$emit("pageHeaderBreadcrumb", arr);
  },
  methods: {
    updateCourse() {
      let _this = this;
      let formData = new FormData();
      formData.append("customizeCourseId", this.$store.getters["organization/getCourseInfo"]().id);
      this.$confirm({
        title: "提示",
        content: `确定更新学生的课程？`,
        onOk() {
          _this.updateCourseLoading = true;
          _this.$http.Course.UpdateUserChildCourseConfig(formData)
            .then(res => {
              _this.updateCourseLoading = false;
                _this.$message.success("操作成功");
                _this.getPageList();
              

            })
            .catch(err => {
              _this.updateCourseLoading = false;
            });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    //获取学生列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex;
      }
      const params = {
        OrganizationId: this.$store.getters["organization/getCourseInfo"]().organizationId,
        ProjectCourseConfigId: this.$store.getters["organization/getCourseInfo"]().id,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      };
      params.gradeClass = undefined;
      this.tableRelevant.tableLoading = true;
      this.$http.Course.getUserCourseProgress(params).then(res => {
        const { data } = res;
        this.tableRelevant.tableDataSource = data.items.map(m => {
          if (m.progress <= 0) {
            m.lastUpdateProgressTime = "--";
          }
          return m;
        });
        this.tableRelevant.tablePagination.total = data.totalCount;
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      })
    },
    //获取年级列表
    getGradeList() {
      this.$http.CommonInterface.getGradeClass({ organizationId: this.$store.getters["organization/getCourseInfo"]().organizationId }).then(res => {
        const { data } = res;
        this.gradeList = data;
      });
    },
    getClassList(val) {
      this.searchForm.gradeId = val[0];
      this.searchForm.classId = val[1];
    },

    //重置
    searchReset() {
      this.searchForm = {
        gradeId: undefined,
        classId: undefined,
        userName: undefined,
        status: undefined,
        gradeClass: undefined,
      };
      this.getPageList(1);
    },

    // 结算
    UserCourseSettlement(record) {
      let formData = new FormData();
      formData.append("userCourseId", record.projectCourseUserId);
      this.$http.Course.getUserCourseSettlement(formData)
        .then(res => {
            this.$message.success(res.message);
         
        }).finally(() => {
        this.tableRelevant.tableLoading = false;
      })
    },


    //查看报告
    getUserCourseChildLookReport(val) {
      this.reportDetailVisible = true;
      this.reportDetailTable.tableLoading = true;
      this.$http.ReportService.UserCourseReportList(val.projectCourseUserId).then(res => {
        this.reportDetailTable.tableDataSource = res.data;
      }).finally(() => {
        this.reportDetailTable.tableLoading = false;
      });
    },
    viewPdf(url) {
      window.open(this.$filterUrl(url));
    },

    //重新生成个人课时报告
    againReport() {
      this.$confirm({
        title: this.selectedRowKeys.length ? `是否重新生成 ${this.selectedRowKeys.length} 名学生个人课时报告?` : "是否重新生成个人课时报告?",
        centered: true,
        onOk: () => {
          const Params = {
            "organizationCourseId": this.$store.getters["organization/getCourseInfo"]().id,
            "userCourseIds": this.selectedRowKeys,
          };
          this.$http.ReportService.UpdateEvaluationReports(Params).then((res) => {
            this.$message.success(res.message);
            this.selectedRowKeys = [];
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.operator {
  margin-top: 15px;
}

/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
  border-bottom: 1px solid #e8e8e8;
}

.self_td:last-of-type {
  border: none;
}
</style>
